<template>
    <article
        class="a-select-filter-checkbox"
        v-click-outside="onClickOutside">
        <div class="a-select-filter-checkbox__trigger-wrap" @click.stop>
            <button
                @click.prevent="toggleFilterList"
                class="a-select-filter-checkbox__trigger"
                :class="{active: filterList}">
                <span class="a-select-filter-checkbox__text">
                    {{ text }}
                </span>
            </button>
            <button
                v-if="text !== 'Выберите тему'"
                @click.prevent="clearSearchField"
                class="a-select-filter-checkbox__clear"></button>
        </div>
        <div
            v-show="filterList"
            class="a-select-filter-checkbox__list-wrap">
            <ul v-if="filterData"
                class="a-select-filter-checkbox__list">
                <li
                    v-for="item in filterData"
                    :key="item.id"
                    class="a-select-filter-checkbox__item">
                    <div class="a-select-filter-checkbox__item-wrap">
                        <button
                            v-if="item.items && item.items.length !== 0"
                            @click.prevent="toggleSubList"
                            class="a-select-filter-checkbox__item-trigger"></button>
                        <input
                            class="a-select-filter-checkbox__item-field"
                            :name="item.name"
                            :id="item.id"
                            type="text"
                            :value="item.name"
                            autocomplete="off"
                            readonly 
                            hidden
                        />
                        <label
                            :for="item.id"
                            class="a-select-filter-checkbox__item-field"
                            @click="handleParentClick(item)"
                        >{{ item.name }}</label>
                    </div>
                    <ul
                        v-if="item.items && item.items.length !== 0"
                        class="a-select-filter-checkbox__sublist  "> 
                        <li
                            v-for="subitem in item.items"
                            class="a-select-filter-checkbox__subitem">
                            <input
                                class="visually-hidden"
                                :name="subitem.name"
                                :id="subitem.id"
                                :value="subitem.id"
                                type="checkbox"
                            />
                            <label :for="subitem.id">
                                {{ subitem.name }}
                            </label>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </article>
</template>

<script>
    import vClickOutside from 'click-outside-vue3'

    export default {
        name: 'SelectFilterCheckbox',
        directives: {
            clickOutside: vClickOutside.directive
        },
        data() {
            return {
                text: 'Выберите тему',
                filterList: false,
                filterActiveFieldsId: [],
                filterActiveFieldsName: []
            }
        },
        props: {
            filterData: Object,
            activeItem: {
                type: String,
                default: null
            }
        },
        methods: {
            toggleFilterList () {
                this.filterList = !this.filterList
            },

            toggleSubList () {
                const targetWrap = event.target.closest('.a-select-filter-checkbox__item-wrap')
                const target = targetWrap.nextElementSibling;
                if (target.offsetHeight === 0) {
                    targetWrap.classList.add('active')
                    target.style.maxHeight = `${target.scrollHeight}px`
                } else {
                    targetWrap.classList.remove('active')
                    target.style.maxHeight = 0
                }
            },

            onClickOutside () {
                if (this.filterList) {
                    this.filterList = false
                    this.checkCheckboxes()
                    this.$emit('chosenFilterItems', this.filterActiveFieldsId)
                }
            },

            checkCheckboxes () {
                const selectFilter = document.querySelector('.a-select-filter-checkbox');
                this.filterActiveFieldsId = [...selectFilter.querySelectorAll('input[type="checkbox"]:checked')]
                    .map(el => el.value)
                this.filterActiveFieldsName = [...selectFilter.querySelectorAll('input[type="checkbox"]:checked')]
                    .map(el => el.getAttribute('name'))

                this.text = this.filterActiveFieldsName.join(', ')
                if (this.filterActiveFieldsName.length === 0) {
                    this.text = 'Выберите тему'
                }

                localStorage.setItem('selectedFilters', JSON.stringify(this.filterActiveFieldsId));
            },

            chosenItem (itemId, itemName, item, isParentClick = false) {
                if (isParentClick) {
                    this.filterActiveFieldsId = [];
                    this.filterActiveFieldsName = [];

                    this.filterActiveFieldsId.push(itemId);
                    this.filterActiveFieldsName.push(itemName);

                    if (item.items && item.items.length > 0) {
                        item.items.forEach(child => {
                            const checkbox = document.getElementById(child.id);
                            checkbox.checked = true;
                        })
                    } else {
                        const checkboxes = document.querySelectorAll('input[type="checkbox"]')
                        checkboxes.forEach(el => el.checked = false);
                    }
                } else {
                    this.checkCheckboxes();
                    if (item.items && item.items.length > 0) {
                        item.items.forEach(child => {
                            const checkbox = document.getElementById(child.id);
                            if (checkbox.checked == true) {
                                this.filterActiveFieldsId.push(child.id);
                                this.filterActiveFieldsName.push(child.name);
                            } else {
                                checkbox.checked = false
                            }
                        })
                    }
                }
                
                this.text = this.filterActiveFieldsName.join(', ') || 'Выберите тему';
                this.filterList = false;
                this.$emit('chosenFilterItems', this.filterActiveFieldsId);
                
                localStorage.setItem('selectedFilters', JSON.stringify(this.filterActiveFieldsId));
            },

            handleParentClick(item) {
                this.chosenItem(item.id, item.name, item, true)
            },

            clearSearchField () {
                this.text = 'Выберите тему'
                this.filterActiveFieldsId = []
                this.filterActiveFieldsName = []
                const checkboxes = document.querySelectorAll('input[type="checkbox"]')
                checkboxes.forEach(el => el.checked = false);
                localStorage.removeItem('selectedFilters');
                this.$emit('chosenFilterItems', [])
                
            },
        },

        mounted() {
            if (localStorage.getItem('selectedFilters')) {
                this.filterActiveFieldsId = JSON.parse(localStorage.getItem('selectedFilters'));
            
                const checkboxes = document.querySelectorAll('input[type="checkbox"]')

                checkboxes.forEach(el => {
                    el.checked = this.filterActiveFieldsId.includes(el.value)
                })
            }

            if (this.activeItem) {
                this.filterActiveFieldsId = this.activeItem.split(',')
            }

            const checkboxes = document.querySelectorAll('input[type="checkbox"]')

            const sections = document.querySelectorAll('input[type="text"]')
            let txt = [];

            checkboxes.forEach((el) => {
                if (this.filterActiveFieldsId.includes(el.value)) {
                    el.checked = true;
                    txt.push(el.getAttribute('name'));
                }
            })

            if (txt.length > 0) {
                this.text = txt.toString();
            } else this.text = 'Выберите тему'

            sections.forEach((el) => {
                if (el.id == this.activeItem && el.value !== '') {
                    this.text = el.getAttribute('name')
                }
            })

            if (this.activeItem === '') {
                this.text = 'Выберите тему'
            }

            // Костыль-заглушка
            switch(this.activeItem) {
                case '856':
                    this.text = 'Жилищное строительство'
                    break
                case '841':
                    this.text = 'Ипотека'
                    break
                case '907':
                    this.text = 'Ипотека'
                    break
                case '838':
                    this.text = 'Ипотека'
                    break
                case '859':
                    this.text = 'Ипотека'
                    break
                case '835':
                    this.text = 'ИЦБ'
                    break
                case '889':
                    this.text = 'ИЦБ'
                    break
                case '844':
                    this.text = 'Опросы населения и застройщиков'
                    break
                case '850':
                    this.text = 'Интересное по рынку'
                    break
            }
            // END Костыль-заглушка
        }
    }
</script>


